import React, { useState, useEffect } from "react";
import { fetchOrganizationEmployee } from "../../../Apis/Employee-api";
import { fetchOrganizationEmployeeAddressTypes } from "../../../Apis/EmployeeAddressType-api";
import { fetchcities } from "../../../Apis/OrganizationLocation";
import { fetchOrganizationResidentialOwnerType } from "../../../Apis/ResidentialOwnershipType-api";
import {
  Box,
  Button,
  Grid,
  Paper,
  MenuItem,
  TextField,
  Checkbox,
  CircularProgress,
  InputLabel,
  Select,
  FormHelperText,
  FormControl,
  FormControlLabel,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  FormGroup,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useNavigate, useParams } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import useEmployeeDataStore from "../../../Zustand/Store/useEmployeeDataStore";

function EmployeeAddressForm({ mode, employeeId }) {
  const { userData } = useAuthStore();
  const org = userData?.organization;
  const { id } = useParams();

  const {
    setAddressData,
    Address,
    getDropdowndata,
    AddressErrors,
    DropDownData,
    addAddress,
    removeAddress,
  } = useEmployeeDataStore();

  const [expanded, setExpanded] = useState("Address 1");

  const handleChangeAccoridan = (panelId) => (event, isExpanded) => {
    setExpanded(isExpanded ? panelId : "");
  };

  const [loading, setLoading] = useState(mode === "edit");
  const [btnLoading, setbtnLoading] = useState(false);
  const [cityOptions, setCity] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [employeeAddressType, setEmployeeAddressType] = useState([]);
  const [residentailtype, setResidentialType] = useState([]);

  let navigate = useNavigate();

  useEffect(() => {
    {
      fetchOrganizationEmployeeAddressTypes(org.organization_id)
        .then((data) => {
          setEmployeeAddressType(data?.addresstype?.data);
        })
        .catch((err) => {
          console.log("err is : ", err);
        });
    }
  }, []);

  useEffect(() => {
    if (inputValue?.length < 2) return;
    fetchcities(inputValue)
      .then((data) => {
        setCity(data.cities);
      })
      .catch((err) => {
        console.error("Error fetching cities:", err);
      });
  }, [inputValue]);

  useEffect(() => {
    {
      fetchOrganizationResidentialOwnerType(org.organization_id)
        .then((data) => {
          setResidentialType(data.residentialtype.data);
        })
        .catch((err) => {
          console.log("err is : ", err);
        });
    }
  }, []);

  const handleChange = (e, idx) => {
    const { name, value } = e.target;

    setAddressData(name, value, idx);
  };

  return (
    <Box px={{ xs: 1, sm: 2, md: 4 }}>
      <Box>
        {Address?.map((item, id) => ({
          name: `Address ${id + 1}`,
          mainData: item,
        }))?.map((section, idx) => (
          <Accordion
            sx={{ mb: 2 }}
            key={section.name}
            expanded={expanded === section.name}
            onChange={handleChangeAccoridan(section.name)}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ fontSize: "15px", fontWeight: "bold" }}
                >
                  {section.name}
                </Typography>
                {idx != 0 && (
                  <DeleteOutlineIcon
                    onClick={(e) => {
                      e.stopPropagation();
                      removeAddress(idx);
                    }}
                    sx={{ color: "error.main", ml: 2 }}
                  />
                )}
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              {expanded === section.name && (
                <Grid item xs={12} md={8}>
                  <Paper elevation={4} sx={{ p: { xs: 2, md: 3 } }}>
                    <Grid container spacing={2}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "column", sm: "row" },
                          justifyContent: "center", // centers the row
                          gap: 2, // space between fields
                          width: "100%", // ensures proper centering
                        }}
                      >
                        <FormControl
                          fullWidth
                          required
                          error={
                            !!AddressErrors?.[idx]
                              ?.organization_employee_address_type_id
                          }
                        >
                          <InputLabel id="employee-address-type-label">
                            Employee Address Type
                          </InputLabel>

                          <Select
                            disabled={mode === "view"}
                            labelId="employee-address-type-label"
                            id="organization_employee_address_type_id"
                            name="organization_employee_address_type_id"
                            value={
                              section?.mainData
                                ?.organization_employee_address_type_id || ""
                            }
                            label="Employee Address Type"
                            onChange={(e) => handleChange(e, idx)}
                            required
                          >
                            {employeeAddressType?.map((option) => (
                              <MenuItem
                                key={
                                  option?.organization_employee_address_type_id
                                }
                                value={
                                  option?.organization_employee_address_type_id
                                }
                              >
                                {option?.employee_address_type_name}
                              </MenuItem>
                            ))}
                          </Select>

                          {AddressErrors?.[idx]
                            ?.organization_employee_address_type_id && (
                            <FormHelperText>
                              {
                                AddressErrors?.[idx]
                                  ?.organization_employee_address_type_id
                              }
                            </FormHelperText>
                          )}
                        </FormControl>

                        <FormControl
                          disabled={mode === "view"}
                          fullWidth
                          error={
                            !!AddressErrors?.[idx]
                              ?.organization_residential_ownership_type_id
                          }
                        >
                          <InputLabel id="employee-ownership-type-label">
                            {" "}
                            Residential Ownership Type
                          </InputLabel>

                          <Select
                            labelId="employee-ownership-type-label"
                            id="organization_residential_ownership_type_id"
                            name="organization_residential_ownership_type_id"
                            value={
                              section?.mainData
                                ?.organization_residential_ownership_type_id ||
                              ""
                            }
                            label="Employee Ownership Type"
                            onChange={(e) => handleChange(e, idx)}
                          >
                            {residentailtype?.map((option) => (
                              <MenuItem
                                key={
                                  option?.organization_residential_ownership_type_id
                                }
                                value={
                                  option?.organization_residential_ownership_type_id
                                }
                              >
                                {option?.residential_ownership_type_name}
                              </MenuItem>
                            ))}
                          </Select>

                          {AddressErrors?.[idx]
                            ?.organization_residential_ownership_type_id && (
                            <FormHelperText>
                              {
                                AddressErrors?.[idx]
                                  ?.organization_residential_ownership_type_id
                              }
                            </FormHelperText>
                          )}
                        </FormControl>

                        <TextField
                          disabled={mode === "view"}
                          fullWidth
                          label="Postal Code"
                          name="postal_code"
                          value={section?.mainData?.postal_code}
                          onChange={(e) => handleChange(e, idx)}
                          error={!!AddressErrors?.[idx]?.postal_code}
                          helperText={AddressErrors?.[idx]?.postal_code}
                          required
                          inputProps={{ maxLength: 20 }}
                        />
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "column", sm: "row" },
                          justifyContent: "center", // centers the row
                          gap: 2, // space between fields
                          width: "100%", // ensures proper centering
                        }}
                      >
                        <TextField
                          disabled={mode === "view"}
                          fullWidth
                          label="Address Line 1"
                          name="address_line1"
                          value={section?.mainData?.address_line1}
                          onChange={(e) => handleChange(e, idx)}
                          error={!!AddressErrors?.[idx]?.address_line1}
                          helperText={AddressErrors?.[idx]?.address_line1}
                          required
                          inputProps={{ maxLength: 100 }}
                        />

                        <TextField
                          disabled={mode === "view"}
                          fullWidth
                          label="Address Line 2"
                          name="address_line2"
                          value={section?.mainData?.address_line2}
                          onChange={(e) => handleChange(e, idx)}
                          error={!!AddressErrors?.[idx]?.address_line2}
                          helperText={AddressErrors?.[idx]?.address_line2}
                          inputProps={{ maxLength: 100 }}
                        />

                        <TextField
                          disabled={mode === "view"}
                          fullWidth
                          label="Address Line 3"
                          name="address_line3"
                          value={section?.mainData?.address_line3}
                          onChange={(e) => handleChange(e, idx)}
                          error={!!AddressErrors?.[idx]?.address_line3}
                          helperText={AddressErrors?.[idx]?.address_line3}
                          inputProps={{ maxLength: 100 }}
                        />
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "column", sm: "row" },
                          justifyContent: "center",
                          gap: 2,
                          width: { xs: "100%", sm: "33%" },
                        }}
                      >
                        <Autocomplete
                          disabled={mode === "view"}
                          options={cityOptions}
                          getOptionLabel={(option) =>
                            typeof option === "string"
                              ? option
                              : option.city_name
                          }
                          fullWidth
                          value={section?.mainData?.city || null}
                          onChange={(event, newValue) => {
                            setAddressData(
                              "general_city_id",
                              newValue?.general_city_id,
                              idx
                            );
                            setAddressData("city", newValue || "", idx);
                          }}
                          onInputChange={(event, newInputValue) => {
                            setInputValue(newInputValue);
                          }}
                          isOptionEqualToValue={(option, value) =>
                            option?.general_city_id === value?.general_city_id
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="City"
                              error={!!AddressErrors?.[idx]?.general_city_id}
                              helperText={AddressErrors?.[idx]?.general_city_id}
                              required
                            />
                          )}
                        />
                      </Box>
                    </Grid>
                  </Paper>
                </Grid>
              )}
            </AccordionDetails>
          </Accordion>
        ))}

        <Button
          disabled={mode === "view"}
          style={{ marginTop: 9 }}
          variant="contained"
          onClick={() => {
            setExpanded(`Address ${Address?.length + 1}`);
            addAddress();
          }}
        >
          Add More
        </Button>
      </Box>
    </Box>
  );
}

export default EmployeeAddressForm;
